export default {"src":"/_next/static/media/man-thumbs-up.mono.d5ed0093.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};